import { useQuery } from '@apollo/client/react';

import GET_DIDS_FOR_API_KEY from '../gql/getDidsForApiKey.gql';
import GET_DIDS_FOR_SWITCH from '../gql/getDidsForSwitch.gql';
import type { DidResource } from '../lib/didsForResource';

/**
 * Whether any number is still attached to an API key or switch. Used to block
 * deleting them from the dashboard. Treat `loading` as "maybe" so a delete can't
 * slip through before the answer arrives.
 */
export const useHasDids = (resource: DidResource, id: string | undefined) => {
  const apiKey = useQuery(GET_DIDS_FOR_API_KEY, {
    variables: { id, first: 1 },
    skip: resource !== 'apiKey' || !id,
  });
  const sw = useQuery(GET_DIDS_FOR_SWITCH, {
    variables: { id, first: 1 },
    skip: resource !== 'switch' || !id,
  });

  const result = resource === 'apiKey' ? apiKey : sw;
  const edges =
    resource === 'apiKey' ? apiKey.data?.didsForApiKey?.edges : sw.data?.didsForSwitch?.edges;

  return {
    hasDids: (edges?.length ?? 0) > 0,
    loading: result.loading,
    error: result.error,
  };
};
